import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { message, Descriptions, Image, Popconfirm, Button } from "antd";
import { EditOutlined, FolderOpenOutlined, FolderOutlined } from "@ant-design/icons";

import { archiveUser, getUser, unArchiveUser } from "../../api/user";
import { getFileUrl } from "../../api/file";

import PageHeader from "../../components/shared/PageHeader"
import LoadingModal from "../../components/shared/LoadingModal";
import BlueButton from "../../components/shared/BlueButton";
import { cn, formatDate } from "../../lib/utils";


export default function UserView() {
    const { userId } = useParams();
    const [isLoading, setLoading] = useState(false);
    const [user, setUser] = useState(null);
    const [documents, setDocuments] = useState([]);
    const navigate = useNavigate();

    const fetchUser = async ({ userId }) => {
        setLoading(true);
        try {
            const result = await getUser(userId);
            setUser(result)
            if (result.attachments && result.attachments.length > 0) {
                updateDocuments(result)
            }
        } catch (err) {
            console.error(err);
            message.error("Something went wrong");
        }
        setLoading(false)
    }

    useEffect(() => {
        fetchUser({ userId });
    }, [userId])



    const updateDocuments = (user) => {
        const docs = [];
        user?.attachments.forEach(
            (doc, index) => {
                if (doc.isActive) {
                    docs.push(
                        {
                            key: `${doc.id + index}`,
                            label: "Document Name",
                            children: doc.fileAttachment.name
                        },
                        {
                            key: `${doc.id + index}`,
                            label: "Expiry Date",
                            children: formatDate(doc.fileAttachment.expireAt),
                        },
                        {
                            key: `${doc.id + index}`,
                            label: "Document",
                            children: doc.fileAttachment.file.name
                        }
                    );
                }
            }
        );
        setDocuments(docs);
    }

    const items = !user ? [] : [
        {
            key: "1",
            label: "First Name",
            children: user.firstName || "",
        },
        {
            key: "2",
            label: "Last Name",
            children: user.lastName || "",
            span: 2
        },
        {
            key: "3",
            label: "Email",
            children: user.email || "N/A",
        },
        {
            key: "4",
            label: "User Type",
            children: <div className="capitalize">{user.role}</div> || "N/A",
            span: 2
        },
        {
            key: "5",
            label: "Phone",
            children: user.phone || "N/A",
            span: 3
        },
        {
            key: "6",
            label: "Rate(AUD)",
            children: "$" + user.rate.rate || "N/A"
        },
        {
            key: "7",
            label: "Rate By",
            children: <div className="capitalize">{user.rate.rateBy}</div> || "N/A",
            span: 2,
        },
        {
            key: "license",
            label: "License",
            children: <p className="capitalize">{user.license || "N/A"}</p>
        },
        {
            key: "ticket",
            label: "Ticket",
            children: <p className="capitalize">{user.ticket || "N/A"}</p>,
            span: 2
        },
        {
            key: "8",
            label: "Attachments",
            labelStyle: { border: "0" },
            contentStyle: { backgroundColor: "rgba(0, 0, 0, 0.02)" },
            span: 3,
        },

        ...documents
    ];

    if (!user) return <LoadingModal />

    return (
        <main className="space-y-6 min-h-full flex flex-col">
            <PageHeader title={user.firstName + " " + user.lastName} home="Users" route="/users" />

            <div className={cn("flex-grow bg-white ml-6 p-6 relative",
                !user.avatar && "pt-20")
            }>

                <div className="absolute right-5 top-5 flex justify-end gap-3 w-full">
                    {/* Archive / Unarchive User */}
                    <Popconfirm
                        title={`${user.isArchived ? 'Unarchive' : 'Archive'} the user`}
                        description={`Are you sure to ${user.isArchived ? 'unarchive' : 'archive'} this user?`}
                        onConfirm={async () => {
                            if (user.isArchived) await unArchiveUser(user.id)
                            else archiveUser(user.id)
                            message.success(`User ${user.isArchived ? 'unarchived' : 'archived'} successfully`);

                            // Set user.isArchived to !user.isArchived
                            fetchUser({ userId });
                        }}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="primary" icon={user.isArchived ? <FolderOpenOutlined /> : <FolderOutlined />}>{user.isArchived ? "Unarchive User" : "Archive User"}</Button>
                    </Popconfirm>

                    <BlueButton className="flex items-center" type="primary" onClick={() => navigate(`/users/form/${user.id}`)}>
                        <EditOutlined />
                        Edit User
                    </BlueButton>
                </div>
                <section className="space-y-6">
                    {
                        user && user.avatar && <Image src={getFileUrl(user.avatar)} width={245}
                            height={245}
                            style={{ objectFit: "cover", }}
                        />
                    }
                    <Descriptions items={items} className="rounded-none" bordered />
                </section>


                {isLoading && <LoadingModal />}

            </div>

        </main>)
}